import { Link } from 'react-router-dom';
import { useEntries, useDeleteEntry } from '../hooks/useApi';
import { EntryList } from '../components/EntryList';
import { useAccount } from '../contexts/AccountContext';

export function Dashboard() {
  const { currentAccountId, currentAccountName, isViewingSharedAccount } = useAccount();
  const { data, isLoading, error } = useEntries(currentAccountId);
  const deleteMutation = useDeleteEntry();

  const handleDelete = (id: string) => {
    deleteMutation.mutate(id);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">
            {isViewingSharedAccount ? `${currentAccountName}'s Entries` : 'Home'}
          </h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-800">
            Failed to load entries: {error instanceof Error ? error.message : 'Unknown error'}
          </div>
        )}

        <div className="mb-6 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">
            {isViewingSharedAccount ? 'Entries' : 'Your Entries'}
            {data && <span className="text-gray-500 font-normal ml-2">({data.total})</span>}
          </h2>

          {!isViewingSharedAccount && (
            <Link
              to="/record/audio"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                  clipRule="evenodd"
                />
              </svg>
              <span>New Entry</span>
            </Link>
          )}
        </div>

        <EntryList
          entries={data?.entries || []}
          isLoading={isLoading}
          onDelete={isViewingSharedAccount ? undefined : handleDelete}
        />
      </main>
    </div>
  );
}
